import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {urlPrefixes} from '../../config/constants'
import {useLocale, useUserType} from '../hocs/hooks'

const BreadcrumbHome = (props: any) => {
  const userType = useUserType()
  const locale = useLocale()
  return <Link to={`/${locale}${urlPrefixes[userType]}/`} {...props}>
    <FormattedMessage id="navbar.home"/>
  </Link>
}
BreadcrumbHome.displayName = 'BreadcrumbHome'
export default BreadcrumbHome
